import { useQuery } from "@tanstack/react-query";
import { getMoleculeDetails } from "@/api/moleculeDetails";

export const useGetMoleculeDetails = (bsadbId: string | undefined) => {
  return useQuery({
    queryKey: ["molecule-details", bsadbId],
    queryFn: () => getMoleculeDetails(bsadbId!),
    enabled: !!bsadbId,
  });
};
